<div class="boxed">
  <div class="site-card">
    <h1>{{ 'change-pin.change-pin' | i18next }}</h1>
    <p>{{ 'change-pin.description' | i18next }}</p>
    <div class="text-center flex-container align-center pin-container">
      <code-input class="margin-b-1" #codeInput
                  [isCodeHidden]="true"
                  (codeCompleted)="setPinCompleted($event)">
      </code-input>
    </div>

  </div>
</div>
